"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleUpdateProjectProductOptions;
const either_1 = require("../../../types/either");
const UpdateProjectProductOptions_1 = require("../../../actions/UpdateProjectProductOptions");
const updateProjectVersion_1 = __importDefault(require("../updateProjectVersion"));
const updateProjectProductOptions_1 = require("../updateProjectProductOptions");
function handleUpdateProjectProductOptions(project, action, dependencies) {
  return __awaiter(this, void 0, void 0, function* () {
    if (!(0, UpdateProjectProductOptions_1.isUpdateProjectProductOptions)(action)) {
      return (0, either_1.left)(new Error('Action does not match update project status schema'));
    }
    const {
      getProduct,
      getART
    } = dependencies;
    const productResult = yield getProduct(project.product.sku);
    if (productResult.isLeft()) {
      return (0, either_1.left)(productResult.value);
    }
    // product is the Magento product, pulled from Magento itself
    // project.product.options is the product options saved to the project data, which may erroneously be different from those stored in Magento
    // action.options is the desired new product options (as requested by a user action)
    const product = productResult.value;
    const getARTResult = yield getART(product.sku);
    if (getARTResult.isLeft()) {
      return (0, either_1.left)(getARTResult.value);
    }
    const newProject = (0, updateProjectVersion_1.default)(project, action);
    const updateProjectProductOptionsResult = (0, updateProjectProductOptions_1.updateProjectProductOptions)({
      project: newProject,
      art: getARTResult.value,
      timestamp: action.timestamp,
      product,
      newOptions: action.options,
      isMobile: action.mobile
    });
    if (updateProjectProductOptionsResult.isLeft()) {
      return (0, either_1.left)(updateProjectProductOptionsResult.value);
    }
    const updateProjectReturn = updateProjectProductOptionsResult.value;
    return (0, either_1.right)(updateProjectReturn);
  });
}